import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';

import {
    defaultSYS5020_R01Filter,
    SYS5020_R01Dto,
    SYS5020_R01Filter,
} from './Dto_SYS5020_R01';

export type { SYS5020_R01Filter };
export { defaultSYS5020_R01Filter };

export interface Store_SYS5020_R01 {
    SYS5020_R01Filter: SYS5020_R01Filter;
    SYS5020_R01PastFilter: SYS5020_R01Filter;
    setSYS5020_R01Filter: (filter: Partial<SYS5020_R01Filter>) => void;
    setSYS5020_R01PastFilter: (filter: SYS5020_R01Filter) => void;

    SYS5020_R01List: SYS5020_R01Dto[];
    setSYS5020_R01List: (dataList: SYS5020_R01Dto[]) => void;

    selectedSYS5020_R01: SYS5020_R01Dto | undefined;
    setSelectedSYS5020_R01: (row: SYS5020_R01Dto | undefined) => void;
    initSelectedSYS5020_R01: () => void;

    columnState: ColumnState[] | null;
    setColumnState: (state: ColumnState[] | null) => void;

    scrollTop: number | null;
    setScrollTop: (top: number | null) => void;

    allCount: number;
    setAllCount: (count: number) => void;

    initData: () => void;
}

export const useSYS5020_R01Store = create<Store_SYS5020_R01>((set) => ({
    SYS5020_R01Filter: defaultSYS5020_R01Filter,
    SYS5020_R01PastFilter: defaultSYS5020_R01Filter,
    setSYS5020_R01Filter: (update) =>
        set((state) => ({
            SYS5020_R01Filter: { ...state.SYS5020_R01Filter, ...update },
        })),
    setSYS5020_R01PastFilter: (filter) => set({ SYS5020_R01PastFilter: filter }),

    SYS5020_R01List: [],
    setSYS5020_R01List: (dataList) =>
        set({
            SYS5020_R01List: dataList.map((item, index) => ({
                ...item,
                valueIndex: index + 1,
            })),
        }),

    selectedSYS5020_R01: undefined,
    setSelectedSYS5020_R01: (row) => set({ selectedSYS5020_R01: row }),
    initSelectedSYS5020_R01: () => set({ selectedSYS5020_R01: undefined }),

    columnState: null,
    setColumnState: (state) => set({ columnState: state }),

    scrollTop: null,
    setScrollTop: (top) => set({ scrollTop: top }),

    allCount: 0,
    setAllCount: (count) => set({ allCount: count }),

    initData: () =>
        set({
            SYS5020_R01Filter: defaultSYS5020_R01Filter,
            SYS5020_R01PastFilter: defaultSYS5020_R01Filter,
            SYS5020_R01List: [],
            selectedSYS5020_R01: undefined,
            columnState: null,
            scrollTop: null,
            allCount: 0,
        }),
}));
